module.exports = __webpack_public_path__ + "img/icon-house.67f04f1d.svg";